import { useEffect, useState } from "react";
import { GripVertical, ArrowUp, ArrowDown, ListOrdered, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export const CategoryOrder = ({ counts, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [names, setNames] = useState(null);
  const [drag, setDrag] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) http.get("/extras/collections/order").then(({ data }) => setNames(data)).catch((e) => toast.error(errMsg(e))); }, [open]);
  const move = (from, to) => {
    if (to < 0 || to >= names.length || from === to) return;
    const n = [...names]; const [x] = n.splice(from, 1); n.splice(to, 0, x); setNames(n);
  };
  const save = async () => {
    setBusy(true);
    try { await http.post("/extras/collections/order", { names }); toast.success("Category order saved — the website feed now uses it"); setOpen(false); onSaved(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <button data-testid="ex-category-order" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 hover:text-stone-900"><ListOrdered size={15} /> Category order</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="ex-category-order-dialog" className="max-w-lg">
          <DialogHeader><DialogTitle className="ex-display text-2xl">Category order</DialogTitle></DialogHeader>
          <p className="text-sm text-stone-500 -mt-2">Drag categories into the order they should appear on pbtravelangel.com.</p>
          {!names ? <div className="py-6 flex items-center gap-2 text-sm text-stone-500"><Loader2 size={14} className="animate-spin" /> Loading…</div> : (
            <ol className="space-y-1.5 max-h-[55vh] overflow-auto">
              {names.map((n, i) => (
                <li key={n} data-testid={`ex-order-item-${i}`} draggable onDragStart={() => setDrag(i)} onDragEnd={() => setDrag(null)}
                  onDragOver={(e) => { e.preventDefault(); if (drag !== null && drag !== i) { move(drag, i); setDrag(i); } }}
                  className={`flex items-center gap-3 border bg-white px-3 py-2.5 rounded-sm cursor-grab active:cursor-grabbing transition-colors ${drag === i ? "border-[#8B6B4A] bg-[#FBF8F2]" : "border-[#E6DDCF]"}`}>
                  <GripVertical size={15} className="text-stone-400" />
                  <span className="ex-mono text-xs text-stone-400 w-5">{i + 1}</span>
                  <span className="flex-1 text-sm">{n}</span>
                  <span className="text-xs text-stone-400">{counts[n] || 0}</span>
                  <button data-testid={`ex-order-up-${i}`} disabled={i === 0} onClick={() => move(i, i - 1)} className="text-stone-500 hover:text-stone-900 disabled:opacity-20"><ArrowUp size={14} /></button>
                  <button data-testid={`ex-order-down-${i}`} disabled={i === names.length - 1} onClick={() => move(i, i + 1)} className="text-stone-500 hover:text-stone-900 disabled:opacity-20"><ArrowDown size={14} /></button>
                </li>
              ))}
            </ol>
          )}
          <button data-testid="ex-category-order-save" disabled={!names || busy} onClick={save} className="ex-btn ex-btn-dark self-end">{busy ? "Saving…" : "Save order"}</button>
        </DialogContent>
      </Dialog>
    </>
  );
};
